import { render, staticRenderFns } from "./DashboardTotalDeal.vue?vue&type=template&id=e29b0684&"
import script from "./DashboardTotalDeal.vue?vue&type=script&lang=js&"
export * from "./DashboardTotalDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports